export const getEvent = state => state.event.eventList;
export const getEventDetails = state => state.event.eventDetails;
